/**
 * @description: 闸机管理
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="turnstile-manage">
        <div class="tsm-list" v-show="showTsmList">
            <h1>闸机管理</h1>
            <el-form :inline="true" :model="tsm_list_form">
                <el-form-item label="门店">
                    <el-select v-model="tsm_list_form.shop_id" filterable placeholder="请选择门店">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="pull-right">
                    <el-button type="primary" @click="tsmAdd">新增闸机设置</el-button>
                    <el-button type="primary" @click="getTsmTable(1)">查询</el-button>
                </el-form-item>
            </el-form>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="tsm_table">
                <el-table-column prop="shop_name" label="门店名称"></el-table-column>
                <el-table-column prop="name" label="闸机名称"></el-table-column>
                <el-table-column prop="gate_sn" label="闸机SN码"></el-table-column>
                <el-table-column prop="ticket" label="核验门票名称">
                    <template slot-scope="scope">
                        {{scope.row.ticket.length > '40' ? scope.row.ticket.slice(0, 40) + '...' : scope.row.ticket}}
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <span class="text-blue" @click="tsmModify(scope.row.id)">修改</span>
                        <span class="text-blue" @click="tsmDel(scope.row.id)">删除</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :page-size="GLOBAL.PAGESIZE"
                :current-page.sync="tsm_page"
                :total="tsm_total"
                @current-change="getTsmTable">
            </el-pagination>
        </div>
        <div class="tsm-edit" v-show="!showTsmList">
            <h2>{{tsm_edit_tit}}</h2>
            <el-form :model="tsm_edit_form" label-width="160px">
                <el-form-item label="门店">
                    <el-select v-model="tsm_edit_form.shop_id" filterable placeholder="请选择门店">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="闸机名称">
                    <el-input placeholder="请输入闸机名称" v-model="tsm_edit_form.name"></el-input>
                </el-form-item>
                <el-form-item label="闸机SN码">
                    <el-input placeholder="请输入闸机SN码" v-model="tsm_edit_form.gate_sn"></el-input>
                </el-form-item>
                <el-form-item label="闸机端口">
                    <el-select v-model="tsm_edit_form.gate_readno" placeholder="请选择闸机端口">
                        <el-option label="默认" value="0"></el-option>
                        <el-option label="A" value="1"></el-option>
                        <el-option label="B" value="2"></el-option>
                    </el-select>
                </el-form-item>
				<el-form-item label="核验门票名称">
                    <el-input v-model="ticket_txt" class="el-ellipsis" clearable placeholder="请选择核验门票名称" @focus="ticketSelect" @clear="ticketDel"></el-input>
				</el-form-item>
                <el-form-item>
                    <el-button @click="showTsmList=true">返回</el-button>
                    <el-button type="primary" @click="tsmEdit">确定</el-button>
                </el-form-item>
            </el-form>
        </div>
        <!-- 门票弹窗 -->
        <div class="select-goods-wrap" ref="ticket_alert">
            <el-row :gutter="20">
                <el-col :span="8">
                    <el-select v-model="ticket_type" filterable clearable placeholder="请选择门票类型" @change="getTicketTable(1)">
                        <el-option v-for="item in ticket_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="10">
                    <el-input placeholder="请输入门票名称" v-model="ticket_name"></el-input>
                </el-col>
                <el-col :span="6">
                    <el-button class="pull-right" type="primary" @click="getTicketTable(1)">查询</el-button>
                </el-col>
            </el-row>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                ref="ticket_table"
                :data="ticket_table"
                @selection-change="getTicketSelect">
                <el-table-column type="selection"></el-table-column>
                <el-table-column prop="category_name" label="类型"></el-table-column>
                <el-table-column prop="name" label="名称"></el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :page-size="GLOBAL.PAGESIZEMINI"
                :current-page.sync="ticket_page"
                :total="ticket_total"
                @current-change="getTicketTable">
            </el-pagination>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                showTsmList: true,
                loading: false,
                shop_list: [],
                ticket_type_list: [],
                tsm_list_form: {
                    shop_id: '',
                },
                tsm_page: 1,
				tsm_total: 0,
                tsm_table: [],
                tsm_edit_id: '',
                tsm_edit_tit: '',
                tsm_edit_form: {
                    shop_id: '',
                    name: '',
                    gate_sn: '',
                    gate_readno: ''
                },
                // 门票弹窗
                ticket_shop_id: '',
				ticket_type: '',
				ticket_name: '',
				ticket_page: 1,
				ticket_total: 0,
                ticket_table: [],
                ticket_table_select: [],
                ticket_txt: '',
                ticket_select: [],

            }
        },
        watch: {
            
        },
        created: function() {
            this.getTicketType()
        },
        mounted: function() {
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.tsm_list_form.shop_id = this.shop_list[0].id
                this.getTsmTable(1)
            })
        },
        methods: {
            // 获取门店
            getShop: function(resolve) {
                const _this = this;

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result
                        _this.shop_list.shift()
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            // 获取门票类型
            getTicketType() {
                const _this = this;

                Vue.axios.post('publicData/api_getTicketCategory', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "type": 1
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.ticket_type_list = res.data.response.result;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            // 门票弹窗列表
			getTicketTable: function(page) {
				const _this = this;

				_this.loading = true;
                Vue.axios.post('Ticket/getList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
                            "page_size": _this.GLOBAL.PAGESIZEMINI,
                            "type": 1,
                            "shop_id": _this.ticket_shop_id,
                            "category_id": _this.ticket_type,
                            "status": 1,
                            "name": _this.ticket_name
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.ticket_total = Number(res.data.response.result.total);
						}
						_this.ticket_table = res.data.response.result.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },



            getTsmTable: function(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('TicketGate/getList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "shop_id": _this.tsm_list_form.shop_id
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.tsm_total = Number(res.data.response.result.total);
						}
						_this.tsm_table = res.data.response.result.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },
            // 删除
			tsmDel(id) {
				const _this = this;

				layer.confirm('删除后，该闸机将无法核验对应门票，确定删除？', {
					btn: ['确定', '取消']
				}, function() {
					Vue.axios.post('TicketGate/delData', {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
                                "id": id
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.msg('删除成功');
							_this.getTsmTable(_this.tsm_page);
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg('出错啦');
					});
				});
            },
            // 点击新增
			tsmAdd() {
                this.tsm_edit_id = ''
                this.tsm_edit_tit = '新增闸机设置'
                this.tsm_edit_form = {
                    shop_id: this.shop_list[0].id,
                    name: '',
                    gate_sn: '',
                    gate_readno: '0'
                }
                this.showTsmList = false
			},
			// 点击修改
			tsmModify(id) {
                const _this = this;

                Vue.axios.post('TicketGate/getData', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        const row = res.data.response.result

                        _this.tsm_edit_id = row.id
                        _this.tsm_edit_tit = '修改闸机设置'
                        _this.tsm_edit_form = {
                            shop_id: row.shop_id,
                            name: row.name,
                            gate_sn: row.gate_sn,
                            gate_readno: row.gate_readno
                        }
                        _this.ticket_select = row.ticket_infos
						let ticket_txt = []
						row.ticket_infos.forEach(_ => {
							ticket_txt.push(_.ticket_name)
						});
						_this.ticket_txt = ticket_txt.join(',')
                        _this.showTsmList = false
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            // 核验门票名称
			ticketSelect: function() {
				const _this = this;

				_this.ticket_shop_id = _this.tsm_edit_form.shop_id
				_this.ticket_type = ''
				_this.ticket_name = ''
				_this.ticket_page = 1
				_this.getTicketTable(1);
				layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['添加门票', true],
                    area: ['700px', '500px'], // 宽高
                    content: $(_this.$refs.ticket_alert)
                }, function() {
					// 保存
					_this.ticket_table_select.forEach(_ => {
                        let isTrue = true;
                        for(let i = 0; i < _this.ticket_select.length; i++) {
                            if(_this.ticket_select[i].ticket_id == _.id) {
                                isTrue = false
                                return false
                            }
                        }
                        if(isTrue) {
                            _this.ticket_select.push({
                                ticket_id: _.id,
                                ticket_name: _.name
                            })
                        }
                    })
					let arr = [];
					_this.ticket_select.forEach(_ => {
						arr.push(_.ticket_name);
					})
					_this.ticket_txt = arr.join(',')
					_this.$refs.ticket_table.clearSelection();
					layer.msg('保存成功');
                });
			},
			ticketDel() {
				this.ticket_txt = '';
				this.ticket_select = [];
			},
			getTicketSelect(val) {
				this.ticket_table_select = val
			},
            // 新增、修改
			tsmEdit() {
                const _this = this;

                let url = "TicketGate/addData"
                let data = {
                    "header": Vue.request_header,
					"request": {
						"param": {
                            "shop_id": _this.tsm_edit_form.shop_id,
                            "name": _this.tsm_edit_form.name,
                            "gate_sn": _this.tsm_edit_form.gate_sn,
                            "gate_readno": _this.tsm_edit_form.gate_readno,
                            "ticket_infos": _this.ticket_select
						}
					},
					"comment": ""
                }
                if(_this.tsm_edit_id) {
                    data.request.param.id = _this.tsm_edit_id;
                    url = "TicketGate/editData";
                }
                Vue.axios({
                    method: 'post',
                    url: url,
                    data: data
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        layer.msg('操作成功')
						_this.getTsmTable(_this.tsm_page)
						_this.showTsmList = true
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                })
            },
        }
    }
</script>
<style lang="less" scoped>
    .select-goods-wrap {
        display: none;
    }

    .el-table {
        margin-top: 20px;
    }

    .tsm-edit {
        .el-form {
            .el-select {
                width: 400px;
            }
            .el-input {
                width: 400px;
            }
		}
    }
</style>